// Core imports
import PropTypes from 'prop-types';

// Misc imports
import { usePrompt } from '../../utils/hooks/usePrompt';

/**
 * This component sets up a navigation prompt using the usePrompt hook.
 * It prompts the user when they attempt to navigate away under the conditions specified by `when`.
 * @param {string} message - The message to display in the confirmation dialog.
 * @param {boolean} when - Condition under which the prompt should be active.
 * @param {function} onConfirm - A callback to execute when the user confirms the navigation.
 * @param {object} rest - Additional props to pass to the usePrompt hook.
 * @returns null - Since it is a hook wrapper component with no visual rendering.
 */
const Prompt = ({ message, when, onConfirm = () => {}, ...rest }) => {
  // usePrompt hook is responsible for showing a modal based on navigation events
  usePrompt({ message, when, onConfirm, ...rest });
  return null; // This component does not render anything
};

Prompt.propTypes = {
  message: PropTypes.string.isRequired,
  when: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func
};

export default Prompt;
